// extracted by mini-css-extract-plugin
module.exports = {"root":"Progress_root__7fkv2","sectionOne":"Progress_sectionOne__x5w13","sectionSecond":"Progress_sectionSecond__TJJ84"};